import { Reveal } from "@/components/motion";

export default function PageHeader({ eyebrow, title, highlight, subtitle }) {
  return (
    <section className="relative overflow-hidden pb-10 pt-36 lg:pt-44">
      <div className="mesh-hero pointer-events-none absolute inset-0" aria-hidden="true" />
      <div className="blob -left-20 top-10 h-72 w-72 bg-dq-orange/20" aria-hidden="true" />
      <div className="dq-container relative">
        <Reveal>
          {eyebrow && <p className="label-eyebrow mb-4">{eyebrow}</p>}
        </Reveal>
        <Reveal delay={0.08}>
          <h1 className="max-w-4xl font-display text-4xl font-extrabold leading-[1.05] tracking-tighter text-dq-ink sm:text-5xl lg:text-6xl">
            {title} {highlight && <span className="gradient-text">{highlight}</span>}
          </h1>
        </Reveal>
        {subtitle && (
          <Reveal delay={0.16}>
            <p className="mt-6 max-w-2xl text-lg leading-relaxed text-dq-muted">{subtitle}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
